<style scoped>
    .vue-modal {
        display: block;
    }
</style>

<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th class="col-md-3">Упаковка</th>
                    <th class="col-md-7">Расходники</th>
                    <th class="col-md-2">Управление</th>
                </tr>
            </thead>
            <tbody>
            <tr v-for="variant in variants">
                <td v-text="variant.title"></td>
                <td>
                    <div class="row">
                        <div class="col-md-6"
                             v-for="consumable in consumables"
                             v-if="isConsumableSelected(consumable.id, variant.id)"
                        >
                            <div class="row product-consumables__consumable-row">

                                <div class="col-md-7 product-consumables__consumable-col">
                                    <span v-text="consumable.title"></span>
                                    <input type="hidden" :name="`consumables[${variant.id}][${consumable.id}]`">
                                </div>
                                <div class="col-md-3 product-consumables__consumable-col">
                                    <input type="text" :name="`consumables[${variant.id}][${consumable.id}][quantity]`"
                                           :value="getVariantConsumableQuantity(variant, consumable.id)"
                                           class="form-control"
                                    >
                                </div>
                                <div class="col-md-2 text-center product-consumables__consumable-col">
                                    <i @click="deleteById(variant.id, consumable.id)" class="fa fa-close text-danger" style="cursor: pointer"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
                <td>
                    <button type="button"
                            class="btn btn-sm btn-default product-consumables__consumable-add-button"
                            @click="openModal(variant.id)">
                        Добавить
                    </button>
                </td>
            </tr>
            </tbody>
        </table>

        <!-- MODAL -->
        <div class="modal vue-modal product-consumables__modal" v-show="is_visible_modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Выбор расходников</h4>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <table-search></table-search>
                        </div>

                        <table-items
                             :columns="columns"
                             :default_sort_key="default_sort_key"
                             :default_sort_order="default_sort_order"
                             :current_route="current_route"
                             :fixed_table="fixed_table"
                             :default_checked="default_checked"
                        ></table-items>

                        <table-pagination
                             :current_route="current_route"
                        ></table-pagination>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default pull-right" @click="closeModal">Закрыть</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['variants', 'consumables'],
        created: function () {
            this.$root.$on('update:checked', this.onCheckedUpdated);
            this.setFirstSelectedConsumables();
        },
        data: function () {
            return {
                fixed_table: false,
                active_variant_id: null,
                is_visible_modal: false,
                selected_consumables: {},

                default_checked: [],
                counter_enabled: true,
                current_route: '/warehouse/consumables',
                default_sort_key: 'id',  // default sorting
                default_sort_order: 'desc',  // asc : desc
                columns: [
                    {code: 'id', width: 1, label: 'id'},
                    {code: 'title', width: 11, label: 'Название', m_width: 8},
                ]
            };
        },
        methods: {
            setFirstSelectedConsumables: function () {
                for (let i = 0; i < this.variants.length; i++) {
                    this.selected_consumables[this.variants[i].id] = this.getVariantConsumablesIds(this.variants[i]);
                }
            },
            getVariantConsumablesIds: function (variant) {
                let ids = [];
                for (let i = 0; i < variant.consumables.length; i++) {
                    ids.push(variant.consumables[i].id);
                }

                return ids;
            },
            isConsumableSelected: function (consumable_id, variant_id) {
                let current_consumables = this.selected_consumables[variant_id] || [];
                for (let i = 0; i < current_consumables.length; i++) {
                    if (current_consumables[i] === consumable_id) {
                        return true;
                    }
                }

                return false;
            },
            openModal: function (variant_id) {
                this.active_variant_id = variant_id;
                this.is_visible_modal = true;
            },
            closeModal: function () {
                this.active_variant_id = null;
                this.is_visible_modal = false;
            },
            onCheckedUpdated: function (new_checked) {
                this.selected_consumables[this.active_variant_id] = new_checked;
            },
            getVariantConsumableQuantity: function (variant, consumable_id) {
                for (let i = 0; i < variant.consumables.length; i++) {
                    if (variant.consumables[i].id === consumable_id) {
                        return variant.consumables[i].pivot.quantity;
                    }
                }

                return 1;
            },
            deleteById: function (variant_id, consumable_id) {
                let index = this.selected_consumables[variant_id].indexOf(consumable_id);
                if (index > -1) {
                    this.selected_consumables[variant_id].splice(index, 1);
                    this.$forceUpdate();
                }
            }
        },
        watch: {
            is_visible_modal:  function () {
                this.default_checked = this.selected_consumables[this.active_variant_id] || [];
            }
        }
    };
</script>
